export const MAIN_CLASS_NAME = 'agents-page';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const GRID_CLASS_NAME = `${CONTENT_CLASS_NAME}__grid`;
export const PAGINATION_ROW_CLASS_NAME = `${MAIN_CLASS_NAME}__pagination-row`;

export const EMPTY_CONTENT_CLASS_NAME = `${CONTENT_CLASS_NAME}_empty`;
export const EMPTY_CONTENT_PLACEHOLDER_CLASS_NAME = `${EMPTY_CONTENT_CLASS_NAME}__placeholder`;

export const NOTHING_FOUND_PLACEHOLDER_CLASS_NAME = `${CONTENT_CLASS_NAME}__nothing-found`;

export const SKELETON_CLASS_NAME = `${CONTENT_CLASS_NAME}__skeleton`;
export const SKELETON_ROW_CLASS_NAME = `${SKELETON_CLASS_NAME}__row`;
export const TOOLBAR_CLASSNAME = `${CONTENT_CLASS_NAME}__toolbar`;

export const SKELETON_ROW_COUNT = 2;
export const SKELETON_COLUMN_COUNT = 3;

export const AGENTS_PAGE_SIZE = 30;
